<template>
  <div>
    <div class="header_box">
      <div class="menu-bar">
        <el-dropdown
          size="medium"
          @command="switchSourceType"
          style="width: 170px"
        >
          <el-button class="menu-btn" type="text">
            {{ currentSourceTypeText
            }}<i class="el-icon-caret-bottom el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="0">答题时间由近到远</el-dropdown-item>
            <el-dropdown-item command="1">答题时间由远到近</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
        <el-dropdown size="medium" @command="switchSourceType2">
          <el-button class="menu-btn" type="text">
            {{ currentSourceTypeText2
            }}<i class="el-icon-caret-bottom el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="0">全部题型</el-dropdown-item>
            <el-dropdown-item command="1">单选题</el-dropdown-item>
            <el-dropdown-item command="2">多选题</el-dropdown-item>
            <el-dropdown-item command="3">判断题</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>
      <div class="switch_box">
        <div class="operation_box">
          <div v-if="delState">
            <el-checkbox
              v-model="selAll"
              :indeterminate="isIndeterminate"
              @change="changeAll"
            ></el-checkbox>
            <p>全选</p>
          </div>
          <div @click="delBtn()" v-if="delState">
            <img src="../../../assets/icon/del_01.png" alt="" />
            <p>删除</p>
          </div>
          <div @click="setBtn()">
            <img
              src="../../../assets/icon/over_01.png"
              alt=""
              v-if="delState"
            />
            <img src="../../../assets/icon/set_01.png" alt="" v-else />
            <p>{{ delState ? "完成" : "管理" }}</p>
          </div>
        </div>
        <el-switch v-model="value" @change="switchChange" active-text="">
        </el-switch>
        <p>答对后自动移除错题</p>
      </div>
    </div>
    <div class="error_box">
      <el-checkbox-group v-model="checkList" :max="10">
        <div
          class="card_list"
          v-for="(item, index) in errorBookList"
          :key="index"
        >
          <el-checkbox
            :label="item.questionId"
            @change="checkChange(item.questionId)"
            class="checkbox"
            v-if="delState"
          ></el-checkbox>

          <div class="type">{{ callPaperType(item.questionType) }}</div>
          <div
            v-html="removeStyle(JSON.parse(item.stem).content)"
            class="text"
            @click="toDetail(index)"
          ></div>
        </div>
      </el-checkbox-group>
      <div class="pagination-box">
        <el-pagination
          class="ou-pagination"
          background
          hide-on-single-page
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="searchParams.pageNum"
          :page-sizes="[10, 20, 30, 40, 50]"
          :page-size="searchParams.pageSize"
          layout="prev, pager, next, sizes, jumper, slot"
          :total="total"
        >
          <el-button @click="getErrorBookList()" class="ou-page-go"
            >GO</el-button
          >
        </el-pagination>
        <noData v-if="total == 0"></noData>
      </div>
    </div>
  </div>
</template>
<script>
import noData from "@/components/noData.vue";
import {
  GetWrongQuestionList,
  delWrongQuestion
} from "@/api/willingLearn/index.js";
export default {
  components: { noData },
  data() {
    return {
      searchParams: {
        pageNum: 1,
        pageSize: 10,
        messageTitle: "",
        isDesc: 0,
        questionType: "0"
      },
      value: false,
      errorBookList: [],
      total: 0,
      paperTypeList: this.paperTypeList(),
      checkList: [],
      delState: false,
      selAll: false,
      isIndeterminate: false
    };
  },
  computed: {
    currentSourceTypeText() {
      let dict = {
        0: "答题时间由近到远",
        1: "答题时间由远到近"
      };
      return dict[this.searchParams.isDesc];
    },
    currentSourceTypeText2() {
      let dict = this.paperTypeList;
      return dict[this.searchParams.questionType].name;
    }
  },
  mounted() {
    this.value =
      localStorage.getItem("automatically-remove") === "true" ? true : false;
    this.paperTypeList.unshift({
      name: "全部题型",
      questionType: 0
    });
    this.getErrorBookList();
  },
  methods: {
    getErrorBookList() {
      let data = {
        questionType:
          this.searchParams.questionType == "0"
            ? ""
            : this.searchParams.questionType,
        isDesc: this.searchParams.isDesc == 1 ? "1" : "0",
        pageNum: this.searchParams.pageNum,
        pageSize: this.searchParams.pageSize
      };
      GetWrongQuestionList(data).then(res => {
        this.errorBookList = res.rows;
        this.total = res.total;
        this.checkList = [];
        this.selAll = false;
        this.isIndeterminate = false;
      });
    },
    // 跳转
    toDetail(index) {
      this.$router.push({
        path: "/willingLearn/paper/errorPaper",
        query: {
          errorBookIndex: index,
          questionType:
            this.searchParams.questionType == 0
              ? ""
              : this.searchParams.questionType,
          isDesc:this.searchParams.isDesc == 1 ? "1" : "0"
        }
      });
    },
    checkChange(value) {
      this.isIndeterminate =
        this.checkList.length > 0 &&
        this.checkList.length < this.errorBookList.length;
      this.selAll = this.errorBookList.length === this.checkList.length;
    },
    setBtn() {
      this.delState = !this.delState;
    },
    delBtn() {
      if (this.checkList.length) {
        this.$confirm("是否要删除该错题?", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning"
        }).then(() => {
          delWrongQuestion({
            questionIds: this.checkList.toString()
          }).then(() => {
            this.getErrorBookList();
          });
        });
      } else {
        this.$message.error("请至少选中一条数据");
      }
    },
    changeAll(e) {
      this.selAll = e;
      this.isIndeterminate = false;
      let list = [];
      this.errorBookList.map((item, index) => {
        list.push(item.questionId);
      });
      this.checkList = e ? list : [];
      console.log(this.checkList);
    },
    removeStyle(e) {
      e = e.replace(/<[^>]+>/g, ""); //去除所有标签，以纯文本展示
      e = e.replace(/\s/gi, ""); //去除空格
      return e;
    },
    switchChange(e) {
      localStorage.setItem("automatically-remove", e);
    },
    handleSizeChange(val) {
      this.searchParams.pageSize = val;
      this.getErrorBookList();
    },
    handleCurrentChange(val) {
      this.searchParams.pageNum = val;
      this.getErrorBookList();
    },
    switchSourceType(value) {
      this.searchParams.isDesc = value;
      this.getErrorBookList();
    },
    switchSourceType2(value) {
      this.searchParams.questionType = value + "";
      this.getErrorBookList();
    }
  }
};
</script>
<style scoped lang="scss">
.header_box {
  width: 100%;
  height: 53px;
  border-bottom: 1px solid #f2f2f2;
  display: flex;
  padding: 0 39px 0 10px;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: center;
  .menu-bar {
    padding: 0 30px;
    .el-button {
      color: #666666;
      padding: 0;
    }
  }
}
.switch_box {
  display: flex;
  align-items: center;
  p {
    font-size: 14px;
    font-family: PingFang SC;
    font-weight: 400;
    color: #333333;
    margin-left: 6px;
  }
  .el-button {
    margin-right: 15px;
  }
  .operation_box {
    display: flex;
    align-items: center;
    div {
      display: flex;
      align-items: center;
      margin-right: 16px;
      cursor: pointer;
      img {
        width: 15px;
        height: 15px;
      }
      p {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        color: #333333;
      }
    }
    div:nth-child(1) {
      color: red;
    }
  }
}
.error_box {
  .card_list {
    width: calc(100% - 80px);
    height: 68px;
    border-bottom: 1px solid #f2f2f2;
    margin: 0 40px;
    box-sizing: border-box;
    display: flex;
    align-items: center;
    .type {
      width: 80px;
      height: 28px;
      background: #ffa83a;
      border-radius: 6px;
      font-size: 14px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #ffffff;
      display: flex;
      justify-content: center;
      align-items: center;
      margin-right: 20px;
      flex-shrink: 0;
    }
    .text {
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      font-size: 16px;
      font-family: PingFang SC;
      font-weight: 400;
      color: #333333;
      cursor: pointer;
    }
    .checkbox {
      margin-right: 15px;
      ::v-deep .el-checkbox__label {
        display: none;
      }
    }
  }
  .pagination-box {
    text-align: right;
    margin: 25px 40px;
  }
}
</style>
